import { parseCookies } from '@cian/utils';
import { EBannerType } from '../../types/analytics';
import { fetchTeaser } from '../../repositories/teaser';
import { getCianAnalyticsObject } from './getCianAnaliticsObject';

interface ITeaserEventArguments {
  action: 'click' | 'show';
  hitUrl: string;
  bannerPlace: string;
}

export function sendFSKTeaserEvent({ action, hitUrl, bannerPlace }: ITeaserEventArguments) {
  const { page } = getCianAnalyticsObject();

  const body = {
    user_id: window.__header_user_id__,
    pageType: page.pageType,
    device_type: page.siteType,
    cid: parseCookies(document.cookie)['_CIAN_GK'],
    items: [
      {
        action,
        bannerType: EBannerType.FSK,
        bannerPlace,
        timestamp: Date.now(),
        dl: window.location.href,
        hitUrl,
      },
    ],
  };

  fetchTeaser(body);
}
